/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.selectChannel = selectChannel;
exports.createChannel = createChannel;
exports.createDirectChannel = createDirectChannel;
exports.patchChannel = patchChannel;
exports.updateChannel = updateChannel;
exports.updateChannelNotifyProps = updateChannelNotifyProps;
exports.getChannel = getChannel;
exports.getChannelAndMyMember = getChannelAndMyMember;
exports.fetchMyChannelsAndMembers = fetchMyChannelsAndMembers;
exports.getMyChannelMembers = getMyChannelMembers;
exports.getChannelMembers = getChannelMembers;
exports.leaveChannel = leaveChannel;
exports.joinChannel = joinChannel;
exports.deleteChannel = deleteChannel;
exports.viewChannel = viewChannel;
exports.getChannels = getChannels;
exports.searchChannels = searchChannels;
exports.getChannelStats = getChannelStats;
exports.addChannelMember = addChannelMember;
exports.removeChannelMember = removeChannelMember;
exports.updateChannelMemberRoles = updateChannelMemberRoles;
exports.updateChannelHeader = updateChannelHeader;
exports.updateChannelPurpose = updateChannelPurpose;
exports.markChannelAsRead = markChannelAsRead;
exports.markChannelAsUnread = markChannelAsUnread;
exports.getChannelMembersByIds = getChannelMembersByIds;
exports.getChannelMember = getChannelMember;
exports.getMyChannelMember = getMyChannelMember;

var _constants = require('../constants');

var _action_types = require('../action_types');

var _preferences = require('./preferences');

var _reduxBatchedActions = require('redux-batched-actions');

var _client = require('../client');

var _errors = require('./errors');

var _helpers = require('./helpers');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectChannel(channelId) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                dispatch({
                                    type: _action_types.ChannelTypes.SELECT_CHANNEL,
                                    data: channelId
                                }, getState);
                            } catch (error) {
                                (0, _errors.logError)(error)(dispatch);
                            }

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

function createChannel(channel, userId) {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var created, member, actions, _getState$entities$ch, channels, myMembers;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            created = void 0;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return _client.Client4.createChannel(channel);

                        case 5:
                            created = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context2.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE,
                                error: _context2.t0
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE,
                                error: _context2.t0
                            }, (0, _errors.getLogErrorAction)(_context2.t0)]), getState);
                            return _context2.abrupt('return', null);

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: _constants.General.CHANNEL_USER_ROLE + ' ' + _constants.General.CHANNEL_ADMIN_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            actions = [];
                            _getState$entities$ch = getState().entities.channels, channels = _getState$entities$ch.channels, myMembers = _getState$entities$ch.myMembers;


                            if (!channels[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_CHANNEL, data: created });
                            }

                            if (!myMembers[created.id]) {
                                actions.push({ type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: member });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions, [{
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }])), getState);

                            return _context2.abrupt('return', created);

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[2, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function createDirectChannel(userId, otherUserId) {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member, preferences;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CREATE_CHANNEL_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createDirectChannel([userId, otherUserId]);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CREATE_CHANNEL_FAILURE, error: _context3.t0 }, (0, _errors.getLogErrorAction)(_context3.t0)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:
                            member = {
                                channel_id: created.id,
                                user_id: userId,
                                roles: _constants.General.CHANNEL_USER_ROLE + ' ' + _constants.General.CHANNEL_ADMIN_ROLE,
                                last_viewed_at: 0,
                                msg_count: 0,
                                mention_count: 0,
                                notify_props: { desktop: 'default', mark_unread: 'all' },
                                last_update_at: created.create_at
                            };
                            preferences = [{ user_id: userId, category: _constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, name: otherUserId, value: 'true' }];


                            (0, _preferences.savePreferences)(userId, preferences)(dispatch, getState);

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: created
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.PreferenceTypes.RECEIVED_PREFERENCES,
                                data: preferences
                            }, {
                                type: _action_types.ChannelTypes.CREATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', created);

                        case 18:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[2, 8]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function patchChannel(channelId, patch) {
    var _this4 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.patchChannel(channelId, patch);

                        case 5:
                            updated = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context4.t0 }, (0, _errors.getLogErrorAction)(_context4.t0)]), getState);
                            return _context4.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 8]]);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function updateChannel(channel) {
    var _this5 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var updated;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_REQUEST }, getState);

                            updated = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.updateChannel(channel);

                        case 5:
                            updated = _context5.sent;
                            _context5.next = 13;
                            break;

                        case 8:
                            _context5.prev = 8;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_FAILURE, error: _context5.t0 }, (0, _errors.getLogErrorAction)(_context5.t0)]), getState);
                            return _context5.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: updated
                            }, {
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', updated);

                        case 15:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5, [[2, 8]]);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function updateChannelNotifyProps(userId, channelId, props) {
    var _this6 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var notifyProps, member, currentNotifyProps;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.NOTIFY_PROPS_REQUEST }, getState);

                            notifyProps = _extends({
                                user_id: userId,
                                channel_id: channelId
                            }, props);
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.updateChannelNotifyProps(notifyProps);

                        case 5:
                            _context6.next = 12;
                            break;

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);

                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.NOTIFY_PROPS_FAILURE, error: _context6.t0 }, (0, _errors.getLogErrorAction)(_context6.t0)]), getState);
                            return _context6.abrupt('return', null);

                        case 12:
                            member = getState().entities.channels.myMembers[channelId] || {};
                            currentNotifyProps = member.notify_props || {};


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_PROPS,
                                data: {
                                    channel_id: channelId,
                                    notifyProps: _extends({}, currentNotifyProps, notifyProps)
                                }
                            }, {
                                type: _action_types.ChannelTypes.NOTIFY_PROPS_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6, [[2, 7]]);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function getChannel(channelId) {
    var _this7 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            data = void 0;
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.getChannel(channelId);

                        case 5:
                            data = _context7.sent;
                            _context7.next = 13;
                            break;

                        case 8:
                            _context7.prev = 8;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context7.t0 }, (0, _errors.getLogErrorAction)(_context7.t0)]), getState);
                            return _context7.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: data
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', data);

                        case 15:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7, [[2, 8]]);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function getChannelAndMyMember(channelId) {
    var _this8 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var channel, member;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_REQUEST }, getState);

                            channel = void 0;
                            member = void 0;
                            _context8.prev = 3;
                            _context8.next = 6;
                            return _client.Client4.getChannel(channelId);

                        case 6:
                            channel = _context8.sent;
                            _context8.next = 9;
                            return _client.Client4.getMyChannelMember(channelId);

                        case 9:
                            member = _context8.sent;
                            _context8.next = 17;
                            break;

                        case 12:
                            _context8.prev = 12;
                            _context8.t0 = _context8['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context8.t0 }, (0, _errors.getLogErrorAction)(_context8.t0)]), getState);
                            return _context8.abrupt('return', null);

                        case 17:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }]), getState);

                            return _context8.abrupt('return', { channel: channel, member: member });

                        case 19:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[3, 12]]);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function fetchMyChannelsAndMembers(teamId) {
    var _this9 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var channels, channelMembers, channelsRequest, channelMembersRequest;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.CHANNELS_REQUEST
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST
                            }]), getState);

                            channels = void 0;
                            channelMembers = void 0;
                            _context9.prev = 3;
                            channelsRequest = _client.Client4.getMyChannels(teamId);
                            channelMembersRequest = _client.Client4.getMyChannelMembers(teamId);
                            _context9.next = 8;
                            return channelsRequest;

                        case 8:
                            channels = _context9.sent;
                            _context9.next = 11;
                            return channelMembersRequest;

                        case 11:
                            channelMembers = _context9.sent;
                            _context9.next = 19;
                            break;

                        case 14:
                            _context9.prev = 14;
                            _context9.t0 = _context9['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNELS_FAILURE, error: _context9.t0 }, { type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context9.t0 }, (0, _errors.getLogErrorAction)(_context9.t0)]), getState);
                            return _context9.abrupt('return', null);

                        case 19:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNELS,
                                teamId: teamId,
                                data: channels
                            }, {
                                type: _action_types.ChannelTypes.CHANNELS_SUCCESS
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);

                            return _context9.abrupt('return', { channels: channels, members: channelMembers });

                        case 21:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[3, 14]]);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function getMyChannelMembers(teamId) {
    var _this10 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var channelMembers, channelMembersRequest;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context10.prev = 2;
                            channelMembersRequest = _client.Client4.getMyChannelMembers(teamId);
                            _context10.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context10.sent;
                            _context10.next = 14;
                            break;

                        case 9:
                            _context10.prev = 9;
                            _context10.t0 = _context10['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_FAILURE, error: _context10.t0 }, (0, _errors.getLogErrorAction)(_context10.t0)]), getState);
                            return _context10.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBERS,
                                data: channelMembers
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MY_MEMBERS_SUCCESS
                            }]), getState);

                            return _context10.abrupt('return', channelMembers);

                        case 16:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10, [[2, 9]]);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function getChannelMembers(channelId) {
    var _this11 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var channelMembers, channelMembersRequest;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST }, getState);

                            channelMembers = void 0;
                            _context11.prev = 2;
                            channelMembersRequest = _client.Client4.getChannelMembers(channelId, page, perPage);
                            _context11.next = 6;
                            return channelMembersRequest;

                        case 6:
                            channelMembers = _context11.sent;
                            _context11.next = 14;
                            break;

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, error: _context11.t0 }, (0, _errors.getLogErrorAction)(_context11.t0)]), getState);
                            return _context11.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
                                data: channelMembers
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS
                            }]), getState);

                            return _context11.abrupt('return', channelMembers);

                        case 16:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11, [[2, 9]]);
        }));

        return function (_x23, _x24) {
            return _ref11.apply(this, arguments);
        };
    }();
}

function leaveChannel(channelId) {
    var _this12 = this;

    return function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var state, currentUserId, _state$entities$chann, channels, myMembers, channel, member;

            return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;
                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            channel = channels[channelId];
                            member = myMembers[channelId];


                            dispatch({
                                type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                data: {
                                    id: channelId,
                                    user_id: currentUserId,
                                    team_id: channel.team_id,
                                    type: channel.type
                                },
                                meta: {
                                    offline: {
                                        effect: function effect() {
                                            return _client.Client4.removeFromChannel(currentUserId, channelId);
                                        },
                                        commit: { type: _action_types.ChannelTypes.LEAVE_CHANNEL },
                                        rollback: function rollback() {
                                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                                data: channel
                                            }, {
                                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                                data: member
                                            }]));
                                        }
                                    }
                                }
                            });

                        case 6:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }));

        return function (_x25, _x26) {
            return _ref12.apply(this, arguments);
        };
    }();
}

function joinChannel(userId, teamId, channelId, channelName) {
    var _this13 = this;

    return function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var member, channel;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.JOIN_CHANNEL_REQUEST }, getState);

                            member = void 0;
                            channel = void 0;
                            _context13.prev = 3;

                            if (!channelId) {
                                _context13.next = 13;
                                break;
                            }

                            _context13.next = 7;
                            return _client.Client4.addToChannel(userId, channelId);

                        case 7:
                            member = _context13.sent;
                            _context13.next = 10;
                            return _client.Client4.getChannel(channelId);

                        case 10:
                            channel = _context13.sent;
                            _context13.next = 20;
                            break;

                        case 13:
                            if (!channelName) {
                                _context13.next = 20;
                                break;
                            }

                            _context13.next = 16;
                            return _client.Client4.getChannelByName(teamId, channelName);

                        case 16:
                            channel = _context13.sent;
                            _context13.next = 19;
                            return _client.Client4.addToChannel(userId, channel.id);

                        case 19:
                            member = _context13.sent;

                        case 20:
                            _context13.next = 27;
                            break;

                        case 22:
                            _context13.prev = 22;
                            _context13.t0 = _context13['catch'](3);

                            (0, _helpers.forceLogoutIfNecessary)(_context13.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.JOIN_CHANNEL_FAILURE, error: _context13.t0 }, (0, _errors.getLogErrorAction)(_context13.t0)]), getState);
                            return _context13.abrupt('return', null);

                        case 27:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                data: channel
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.JOIN_CHANNEL_SUCCESS
                            }]), getState);

                            return _context13.abrupt('return', { channel: channel, member: member });

                        case 29:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13, [[3, 22]]);
        }));

        return function (_x27, _x28) {
            return _ref13.apply(this, arguments);
        };
    }();
}

function deleteChannel(channelId) {
    var _this14 = this;

    return function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(dispatch, getState) {
            var entities, _entities$channels, channels, currentChannelId, channel, defaultChannelId, teamId;

            return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.DELETE_CHANNEL_REQUEST }, getState);

                            _context14.prev = 1;
                            _context14.next = 4;
                            return _client.Client4.deleteChannel(channelId);

                        case 4:
                            _context14.next = 11;
                            break;

                        case 6:
                            _context14.prev = 6;
                            _context14.t0 = _context14['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context14.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.DELETE_CHANNEL_FAILURE, error: _context14.t0 }, (0, _errors.getLogErrorAction)(_context14.t0)]), getState);
                            return _context14.abrupt('return', null);

                        case 11:
                            entities = getState().entities;
                            _entities$channels = entities.channels, channels = _entities$channels.channels, currentChannelId = _entities$channels.currentChannelId;

                            if (channelId === currentChannelId) {
                                channel = Object.keys(channels).filter(function (key) {
                                    return channels[key].name === _constants.General.DEFAULT_CHANNEL;
                                });
                                defaultChannelId = '';

                                if (channel.length) {
                                    defaultChannelId = channel[0];
                                }

                                dispatch({ type: _action_types.ChannelTypes.SELECT_CHANNEL, data: defaultChannelId }, getState);
                            }

                            teamId = channels[channelId] ? channels[channelId].team_id : '';


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_DELETED,
                                data: { id: channelId, team_id: teamId }
                            }, {
                                type: _action_types.ChannelTypes.DELETE_CHANNEL_SUCCESS
                            }]), getState);

                            return _context14.abrupt('return', true);

                        case 17:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14, [[1, 6]]);
        }));

        return function (_x29, _x30) {
            return _ref14.apply(this, arguments);
        };
    }();
}

function viewChannel(channelId) {
    var _this15 = this;

    var prevChannelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_REQUEST }, getState);

                            _context15.prev = 1;
                            _context15.next = 4;
                            return _client.Client4.viewMyChannel(channelId, prevChannelId);

                        case 4:
                            _context15.next = 11;
                            break;

                        case 6:
                            _context15.prev = 6;
                            _context15.t0 = _context15['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context15.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_FAILURE, error: _context15.t0 }, (0, _errors.getLogErrorAction)(_context15.t0)]), getState);
                            return _context15.abrupt('return', null);

                        case 11:

                            dispatch({ type: _action_types.ChannelTypes.UPDATE_LAST_VIEWED_SUCCESS }, getState);

                            return _context15.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15, [[1, 6]]);
        }));

        return function (_x32, _x33) {
            return _ref15.apply(this, arguments);
        };
    }();
}

function getChannels(teamId) {
    var _this16 = this;

    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.CHANNELS_CHUNK_SIZE;

    return function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context16.prev = 2;
                            _context16.next = 5;
                            return _client.Client4.getChannels(teamId, page, perPage);

                        case 5:
                            channels = _context16.sent;
                            _context16.next = 13;
                            break;

                        case 8:
                            _context16.prev = 8;
                            _context16.t0 = _context16['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context16.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context16.t0 }, (0, _errors.getLogErrorAction)(_context16.t0)]), getState);
                            return _context16.abrupt('return', null);

                        case 13:
                            _context16.t1 = dispatch;
                            _context16.t2 = _reduxBatchedActions.batchActions;
                            _context16.t3 = _action_types.ChannelTypes.RECEIVED_CHANNELS;
                            _context16.t4 = teamId;
                            _context16.next = 19;
                            return channels;

                        case 19:
                            _context16.t5 = _context16.sent;
                            _context16.t6 = {
                                type: _context16.t3,
                                teamId: _context16.t4,
                                data: _context16.t5
                            };
                            _context16.t7 = {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            };
                            _context16.t8 = [_context16.t6, _context16.t7];
                            _context16.t9 = (0, _context16.t2)(_context16.t8);
                            _context16.t10 = getState;
                            (0, _context16.t1)(_context16.t9, _context16.t10);
                            return _context16.abrupt('return', channels);

                        case 27:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16, [[2, 8]]);
        }));

        return function (_x36, _x37) {
            return _ref16.apply(this, arguments);
        };
    }();
}

function searchChannels(teamId, term) {
    var _this17 = this;

    return function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(dispatch, getState) {
            var channels;
            return regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.GET_CHANNELS_REQUEST }, getState);

                            channels = void 0;
                            _context17.prev = 2;
                            _context17.next = 5;
                            return _client.Client4.searchChannels(teamId, term);

                        case 5:
                            channels = _context17.sent;
                            _context17.next = 13;
                            break;

                        case 8:
                            _context17.prev = 8;
                            _context17.t0 = _context17['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context17.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.GET_CHANNELS_FAILURE, error: _context17.t0 }, (0, _errors.getLogErrorAction)(_context17.t0)]), getState);
                            return _context17.abrupt('return', null);

                        case 13:
                            _context17.t1 = dispatch;
                            _context17.t2 = _reduxBatchedActions.batchActions;
                            _context17.t3 = _action_types.ChannelTypes.RECEIVED_CHANNELS;
                            _context17.t4 = teamId;
                            _context17.next = 19;
                            return channels;

                        case 19:
                            _context17.t5 = _context17.sent;
                            _context17.t6 = {
                                type: _context17.t3,
                                teamId: _context17.t4,
                                data: _context17.t5
                            };
                            _context17.t7 = {
                                type: _action_types.ChannelTypes.GET_CHANNELS_SUCCESS
                            };
                            _context17.t8 = [_context17.t6, _context17.t7];
                            _context17.t9 = (0, _context17.t2)(_context17.t8);
                            _context17.t10 = getState;
                            (0, _context17.t1)(_context17.t9, _context17.t10);
                            return _context17.abrupt('return', channels);

                        case 27:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17, [[2, 8]]);
        }));

        return function (_x38, _x39) {
            return _ref17.apply(this, arguments);
        };
    }();
}

function getChannelStats(channelId) {
    var _this18 = this;

    return function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(dispatch, getState) {
            var stat;
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.CHANNEL_STATS_REQUEST }, getState);

                            stat = void 0;
                            _context18.prev = 2;
                            _context18.next = 5;
                            return _client.Client4.getChannelStats(channelId);

                        case 5:
                            stat = _context18.sent;
                            _context18.next = 13;
                            break;

                        case 8:
                            _context18.prev = 8;
                            _context18.t0 = _context18['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context18.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.CHANNEL_STATS_FAILURE, error: _context18.t0 }, (0, _errors.getLogErrorAction)(_context18.t0)]), getState);
                            return _context18.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_STATS,
                                data: stat
                            }, {
                                type: _action_types.ChannelTypes.CHANNEL_STATS_SUCCESS
                            }]), getState);

                            return _context18.abrupt('return', stat);

                        case 15:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18, [[2, 8]]);
        }));

        return function (_x40, _x41) {
            return _ref18.apply(this, arguments);
        };
    }();
}

function addChannelMember(channelId, userId) {
    var _this19 = this;

    return function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context19.prev = 2;
                            _context19.next = 5;
                            return _client.Client4.addToChannel(userId, channelId);

                        case 5:
                            member = _context19.sent;
                            _context19.next = 13;
                            break;

                        case 8:
                            _context19.prev = 8;
                            _context19.t0 = _context19['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context19.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error: _context19.t0 }, (0, _errors.getLogErrorAction)(_context19.t0)]), getState);
                            return _context19.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                data: member
                            }, {
                                type: _action_types.ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS
                            }], 'ADD_CHANNEL_MEMBER.BATCH'), getState);

                            return _context19.abrupt('return', member);

                        case 15:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19, [[2, 8]]);
        }));

        return function (_x42, _x43) {
            return _ref19.apply(this, arguments);
        };
    }();
}

function removeChannelMember(channelId, userId) {
    var _this20 = this;

    return function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context20.prev = 1;
                            _context20.next = 4;
                            return _client.Client4.removeFromChannel(userId, channelId);

                        case 4:
                            _context20.next = 11;
                            break;

                        case 6:
                            _context20.prev = 6;
                            _context20.t0 = _context20['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context20.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_FAILURE, error: _context20.t0 }, (0, _errors.getLogErrorAction)(_context20.t0)]), getState);
                            return _context20.abrupt('return', null);

                        case 11:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_CHANNEL,
                                data: { user_id: userId },
                                id: channelId
                            }, {
                                type: _action_types.ChannelTypes.REMOVE_CHANNEL_MEMBER_SUCCESS,
                                id: channelId
                            }], 'REMOVE_CHANNEL_MEMBER.BATCH'), getState);

                            return _context20.abrupt('return', true);

                        case 13:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20, [[1, 6]]);
        }));

        return function (_x44, _x45) {
            return _ref20.apply(this, arguments);
        };
    }();
}

function updateChannelMemberRoles(channelId, userId, roles) {
    var _this21 = this;

    return function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(dispatch, getState) {
            var actions, membersInChannel;
            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            dispatch({ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_REQUEST }, getState);

                            _context21.prev = 1;
                            _context21.next = 4;
                            return _client.Client4.updateChannelMemberRoles(channelId, userId, roles);

                        case 4:
                            _context21.next = 11;
                            break;

                        case 6:
                            _context21.prev = 6;
                            _context21.t0 = _context21['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context21.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_FAILURE, error: _context21.t0 }, (0, _errors.getLogErrorAction)(_context21.t0)]), getState);
                            return _context21.abrupt('return', null);

                        case 11:
                            actions = [{
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_MEMBER_SUCCESS
                            }];
                            membersInChannel = getState().entities.channels.membersInChannel[channelId];

                            if (membersInChannel && membersInChannel[userId]) {
                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER,
                                    data: _extends({}, membersInChannel[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context21.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this21, [[1, 6]]);
        }));

        return function (_x46, _x47) {
            return _ref21.apply(this, arguments);
        };
    }();
}

function updateChannelHeader(channelId, header) {
    var _this22 = this;

    return function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_HEADER,
                                data: {
                                    channelId: channelId,
                                    header: header
                                }
                            }, getState);

                        case 1:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this22);
        }));

        return function (_x48, _x49) {
            return _ref22.apply(this, arguments);
        };
    }();
}

function updateChannelPurpose(channelId, purpose) {
    var _this23 = this;

    return function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            dispatch({
                                type: _action_types.ChannelTypes.UPDATE_CHANNEL_PURPOSE,
                                data: {
                                    channelId: channelId,
                                    purpose: purpose
                                }
                            }, getState);

                        case 1:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this23);
        }));

        return function (_x50, _x51) {
            return _ref23.apply(this, arguments);
        };
    }();
}

function markChannelAsRead(channelId, prevChannelId) {
    var _this24 = this;

    return function () {
        var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(dispatch, getState) {
            var state, teamMembers, _state$entities$chann2, channels, myMembers, channel, channelMember, actions, totalMsgCount, teamMember, teamMsgCount, prevChannel, prevChannelMember, prevTotalMsgCount, _teamMsgCount;

            return regeneratorRuntime.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            state = getState();
                            teamMembers = state.entities.teams.myMembers;
                            _state$entities$chann2 = state.entities.channels, channels = _state$entities$chann2.channels, myMembers = _state$entities$chann2.myMembers;
                            channel = channels[channelId];
                            channelMember = myMembers[channelId];
                            actions = [];
                            totalMsgCount = 0;
                            teamMember = void 0;

                            if (channel && channelMember) {
                                totalMsgCount = channel.total_msg_count;

                                if (channel.team_id) {
                                    teamMember = _extends({}, teamMembers[channel.team_id]);
                                    teamMember.mention_count = teamMember.mention_count - channelMember.mention_count;

                                    teamMsgCount = 0;

                                    if (totalMsgCount) {
                                        teamMsgCount = totalMsgCount - channelMember.msg_count;
                                    }
                                    teamMember.msg_count = teamMember.msg_count - teamMsgCount;
                                }

                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_LAST_VIEWED,
                                    data: {
                                        channel_id: channelId,
                                        last_viewed_at: channelMember.last_viewed_at,
                                        total_msg_count: totalMsgCount
                                    }
                                });
                            }

                            if (prevChannelId && channelId !== prevChannelId) {
                                prevChannel = channels[prevChannelId];
                                prevChannelMember = myMembers[prevChannelId];
                                prevTotalMsgCount = 0;

                                if (prevChannel && prevChannelMember) {
                                    prevTotalMsgCount = prevChannel.total_msg_count;

                                    if (prevChannel.team_id) {
                                        // if the channel is a GM or DM we don't have the teamMember
                                        if (!teamMember) {
                                            teamMember = _extends({}, teamMembers[prevChannel.team_id]);
                                        }
                                        teamMember.mention_count = teamMember.mention_count - prevChannelMember.mention_count;

                                        _teamMsgCount = 0;

                                        if (prevTotalMsgCount) {
                                            _teamMsgCount = prevTotalMsgCount - prevChannelMember.msg_count;
                                        }
                                        teamMember.msg_count = teamMember.msg_count - _teamMsgCount;
                                    }

                                    actions.push({
                                        type: _action_types.ChannelTypes.RECEIVED_LAST_VIEWED,
                                        data: {
                                            channel_id: prevChannelId,
                                            last_viewed_at: new Date().getTime(),
                                            total_msg_count: prevTotalMsgCount
                                        }
                                    });
                                }
                            }

                            if (teamMember) {
                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS,
                                    data: [teamMember]
                                });
                            }

                            if (actions.length) {
                                dispatch((0, _reduxBatchedActions.batchActions)([].concat(actions)), getState);
                            }

                        case 12:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this24);
        }));

        return function (_x52, _x53) {
            return _ref24.apply(this, arguments);
        };
    }();
}

function markChannelAsUnread(teamId, channelId, mentionsArray) {
    var _this25 = this;

    return function () {
        var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(dispatch, getState) {
            var state, _state$entities$chann3, channels, myMembers, teamMembers, currentUserId, actions, wasMentioned, mentions, channel, member, teamMember;

            return regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            state = getState();
                            _state$entities$chann3 = state.entities.channels, channels = _state$entities$chann3.channels, myMembers = _state$entities$chann3.myMembers;
                            teamMembers = state.entities.teams.myMembers;
                            currentUserId = state.entities.users.currentUserId;
                            actions = [];
                            wasMentioned = false;

                            if (mentionsArray) {
                                mentions = JSON.parse(mentionsArray);

                                if (mentions.indexOf(currentUserId) !== -1) {
                                    wasMentioned = true;
                                }
                            }

                            // if we have the channel and the channel member in the store
                            if (channels[channelId] && myMembers[channelId]) {
                                channel = _extends({}, channels[channelId]);
                                member = _extends({}, myMembers[channelId]);


                                channel.total_msg_count++;
                                if (member.notify_props && member.notify_props.mark_unread === _constants.General.MENTION) {
                                    member.msg_count++;
                                }

                                if (wasMentioned) {
                                    member.mention_count++;
                                }

                                actions.push({
                                    type: _action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER,
                                    data: member
                                }, {
                                    type: _action_types.ChannelTypes.RECEIVED_CHANNEL,
                                    data: channel
                                });
                            }

                            if (teamId) {
                                teamMember = _extends({}, teamMembers[teamId]);

                                teamMember.msg_count++;
                                if (wasMentioned) {
                                    teamMember.mention_count++;
                                }

                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS,
                                    data: [teamMember]
                                });
                            }

                            if (actions.length) {
                                dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);
                            }

                        case 10:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this25);
        }));

        return function (_x54, _x55) {
            return _ref25.apply(this, arguments);
        };
    }();
}

function getChannelMembersByIds(channelId, userIds) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMembersByIds, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBERS, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userIds);
}

function getChannelMember(channelId, userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId, userId);
}

function getMyChannelMember(channelId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyChannelMember, _action_types.ChannelTypes.CHANNEL_MEMBERS_REQUEST, [_action_types.ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, _action_types.ChannelTypes.CHANNEL_MEMBERS_SUCCESS], _action_types.ChannelTypes.CHANNEL_MEMBERS_FAILURE, channelId);
}

exports.default = {
    selectChannel: selectChannel,
    createChannel: createChannel,
    createDirectChannel: createDirectChannel,
    updateChannel: updateChannel,
    patchChannel: patchChannel,
    updateChannelNotifyProps: updateChannelNotifyProps,
    getChannel: getChannel,
    fetchMyChannelsAndMembers: fetchMyChannelsAndMembers,
    getMyChannelMembers: getMyChannelMembers,
    getChannelMembersByIds: getChannelMembersByIds,
    leaveChannel: leaveChannel,
    joinChannel: joinChannel,
    deleteChannel: deleteChannel,
    viewChannel: viewChannel,
    getChannels: getChannels,
    searchChannels: searchChannels,
    getChannelStats: getChannelStats,
    addChannelMember: addChannelMember,
    removeChannelMember: removeChannelMember,
    updateChannelHeader: updateChannelHeader,
    updateChannelPurpose: updateChannelPurpose,
    markChannelAsRead: markChannelAsRead,
    markChannelAsUnread: markChannelAsUnread
};



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/actions/channels.js
// module id = 82
// module chunks = 60